"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Validator = require("validatorjs");
var context_1 = require("./context");
var utils_1 = require("./utils");
function isConfigParamValid(param) {
    return param && typeof param === 'object' && !Array.isArray(param);
}
exports.isConfigParamValid = isConfigParamValid;
function validateConfigParams(formName, params) {
    var nonUndefinedParams = params.filter(function (p) { return p !== undefined; });
    if (!nonUndefinedParams.every(function (param) { return isConfigParamValid(param); })) {
        throw new Error('Error validating form initialization parameters');
    }
    if (!formName || typeof formName !== 'string') {
        throw new Error('Form name should be non empty string');
    }
}
exports.validateConfigParams = validateConfigParams;
// tslint:disable-next-line
function createForm(formName, formDefinition) {
    if (formDefinition === void 0) { formDefinition = {}; }
    var validator = formDefinition.validator, schema = formDefinition.schema;
    // todo, run in dev mode only
    validateConfigParams(formName, [validator, schema]);
    // tslint:disable-next-line:variable-name
    return function (FormComponent) {
        var FormUI = /** @class */ (function (_super) {
            __extends(FormUI, _super);
            function FormUI(props) {
                var _this = _super.call(this, props) || this;
                if (props.schema && !isConfigParamValid(props.schema)) {
                    throw new Error('Attribute "schema" provided to Form has incorrect format. Object expected');
                }
                if (!props.onSubmit) {
                    throw new Error("Attribute \"onSubmit\" is Required for <" + FormComponent.name + " /> component");
                }
                var fullSchema = (schema || props.schema) && Object.assign({}, schema, props.schema);
                // this will throw if form already exist
                // tslint:disable-next-line:max-line-length
                _this.form = props.formStore.registerForm(formName, props.onSubmit, { schema: fullSchema, validator: validator });
                return _this;
            }
            FormUI.prototype.componentWillUnmount = function () {
                if (this.props.keepState) {
                    this.props.formStore.detachForm(formName);
                }
                else {
                    this.destroyForm();
                }
            };
            FormUI.prototype.destroyForm = function () {
                // to avoid this.props.formStore is possibly undefined
                this.props.formStore.unRegisterForm(formName);
            };
            FormUI.prototype.render = function () {
                return (React.createElement(context_1.FormContext.Provider, { value: this.form },
                    React.createElement(FormComponent, __assign({ valid: this.form.isValid, dirty: this.form.isDirty, submitting: this.form.submitting, submitError: this.form.submitError, step: this.form.currentStep, submit: this.form.submit, reset: this.form.reset, previous: this.form.restoreSnapshot, next: this.form.takeSnapshot, destroy: this.destroyForm.bind(this, false) }, utils_1.omit(this.props, ['schema', 'onSubmit', 'formStore'])))));
            };
            FormUI = __decorate([
                mobx_react_1.inject('formStore'),
                mobx_react_1.observer
                // tslint:disable-next-line:max-line-length
                ,
                __metadata("design:paramtypes", [Object])
            ], FormUI);
            return FormUI;
        }(React.Component));
        return FormUI;
    };
}
exports.createForm = createForm;
function configureValidatorjs(configParameters) {
    if (configParameters.language) {
        Validator.useLang(configParameters.language);
    }
    if (configParameters.setAttributeFormatter) {
        Validator.setAttributeFormatter(configParameters.setAttributeFormatter);
    }
}
exports.configureValidatorjs = configureValidatorjs;
//# sourceMappingURL=createForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/createForm.js
// module id = 31
// module chunks = 0